import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { transferServices } from '../transferServices'
import { SavingGoalTransferInPayload } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export interface IOptionsUseMutation<TData> {
  onSuccess?: (data: TData) => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useCreateGoalTransferIn = (
  options?: IOptionsUseMutation<void>,
) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  const mutation = useMutation<void, Error, SavingGoalTransferInPayload>({
    mutationFn: transferServices.createGoalTransferIn,
    onSuccess: (data) => {
      // Invalidate related queries to refresh data
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SAVINGS_GOAL],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SAVING_GOALS],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.WALLET],
      })

      // Remove cached transactions and history to force refresh
      queryClient.removeQueries({
        queryKey: [QUERY_KEYS.TRANSACTIONS],
      })
      queryClient.removeQueries({
        queryKey: [QUERY_KEYS.SAVINGS_GOAL_HISTORY],
      })

      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      if (options?.onError) {
        options?.onError({
          errorMessage: t('api:errors.somethingWrong'),
          code: 'TRANSFER_IN_ERROR',
        })
      }
    },
  })

  return {
    ...mutation,
  }
}
